/* istanbul ignore file */
import { sbMsgBusInstance as sbMsgBus } from "../../mbus";
export const BettingSlipTopics = {
    Translate: {
        SendToTop: sbMsgBus.sbPrefix + "SendToTop",
        SendToBottom: sbMsgBus.sbPrefix + "SendToBottom",
        MoveTo: sbMsgBus.sbPrefix + "MoveTo",
    }
};
//# sourceMappingURL=BettingSlipTopics.js.map